module.exports = __webpack_public_path__ + "img/snacks3.5fa2c8c1.jpg";